import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { FOUNDATION } from "@/lib/api";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#061729] text-ivory mt-20">
      <div className="heritage-divider" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={FOUNDATION.logo}
                alt="logo"
                className="w-14 h-14 rounded-full object-cover ring-2 ring-amber-400/70"
              />
              <div>
                <div className="font-display text-xl text-white">{FOUNDATION.name}</div>
                <div className="font-eng text-[10px] uppercase tracking-wide text-amber-400">
                  {FOUNDATION.nameEng}
                </div>
              </div>
            </div>
            <p className="text-sm text-slate-300 leading-relaxed">
              पर्यटन, संस्कृति, विरासत, शोध, जागरूकता एवं दस्तावेज़ीकरण के लिए समर्पित एक सांस्कृतिक
              एवं शोध संस्था। ज्ञान एवं प्रकाशन का डिजिटल मंच।
            </p>
          </div>

          <div>
            <h4 className="text-amber-400 font-semibold mb-4 text-lg">मुख्य कड़ियाँ</h4>
            <ul className="space-y-2 text-sm text-slate-300">
              <li><Link to="/about" className="hover:text-amber-300">हमारे बारे में</Link></li>
              <li><Link to="/initiatives" className="hover:text-amber-300">हमारी पहल</Link></li>
              <li><Link to="/gallery" className="hover:text-amber-300">फोटो गैलरी</Link></li>
              <li><Link to="/contact" className="hover:text-amber-300">संपर्क करें</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-amber-400 font-semibold mb-4 text-lg">ज्ञान एवं प्रकाशन</h4>
            <ul className="space-y-2 text-sm text-slate-300">
              <li><Link to="/library" className="hover:text-amber-300">पुस्तकालय</Link></li>
              <li><Link to="/articles" className="hover:text-amber-300">लेख</Link></li>
              <li><Link to="/research" className="hover:text-amber-300">शोध एवं प्रकाशन</Link></li>
              <li><Link to="/magazine" className="hover:text-amber-300">टूरिस्ट संदेश मासिक</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-amber-400 font-semibold mb-4 text-lg">संपर्क</h4>
            <ul className="space-y-3 text-sm text-slate-300">
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-1 text-amber-400 shrink-0" />
                <span>{FOUNDATION.address}</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={16} className="text-amber-400 shrink-0" />
                <a href={`tel:${FOUNDATION.phone.replace(/\s/g, "")}`} className="hover:text-amber-300 font-eng">
                  {FOUNDATION.phone}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={16} className="text-amber-400 shrink-0" />
                <a href={`mailto:${FOUNDATION.email}`} className="hover:text-amber-300 font-eng">
                  {FOUNDATION.email}
                </a>
              </li>
            </ul>
            <div className="flex gap-3 mt-4">
              <a href={FOUNDATION.facebook} target="_blank" rel="noopener noreferrer"
                 data-testid="footer-facebook-link"
                 className="w-10 h-10 rounded-full bg-white/10 hover:bg-amber-500 flex items-center justify-center transition-colors">
                <i className="fa-brands fa-facebook-f text-white" />
              </a>
              <a href={FOUNDATION.instagram} target="_blank" rel="noopener noreferrer"
                 data-testid="footer-instagram-link"
                 className="w-10 h-10 rounded-full bg-white/10 hover:bg-amber-500 flex items-center justify-center transition-colors">
                <i className="fa-brands fa-instagram text-white" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-slate-400 text-center">
            © {new Date().getFullYear()} {FOUNDATION.nameEng}. सर्वाधिकार सुरक्षित।
          </p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="text-xs text-slate-500 hover:text-amber-400 font-eng">
            प्रबंधक लॉगिन (Admin)
          </Link>
        </div>
      </div>
    </footer>
  );
};
